module.exports = __webpack_public_path__ + "static/media/13.eb52e112.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/13.png
// module id = 1223
// module chunks = 0